import CircleIcon from '@mui/icons-material/Circle';
import '../App.css';
import { StyleConstants, Styles } from '../Styles';

const BrownLightIcon = () => {
    return (
        <CircleIcon 
            sx={{
                fill: StyleConstants.faultLevelTwo,
                ...Styles.light,
            }}
        />
    );
};

export default BrownLightIcon;